module.exports = __webpack_public_path__ + "static/media/2b883332-01dc-4b55-ac6a-d24c84f0e334.dba15f99.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/Fonts/2b883332-01dc-4b55-ac6a-d24c84f0e334.ttf
// module id = 96
// module chunks = 0